/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { EditorType } from '@ckeditor/ckeditor5-metadata';

export function isClassicEditor( selectedEditorType: EditorType ): boolean {
	return selectedEditorType === 'ClassicEditor';
}
